import { render } from "./ThanksPointList.vue?vue&type=template&id=0dd348e6&scoped=true&ts=true"
import script from "./ThanksPointList.vue?vue&type=script&lang=ts"
export * from "./ThanksPointList.vue?vue&type=script&lang=ts"

import "./ThanksPointList.vue?vue&type=style&index=0&id=0dd348e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd348e6"]])

export default __exports__